import { DynamicContentComponent } from './dynamic-content.service.type';

export const DYNAMIC_CONTENT_SERVICE_ENDPOINTS = {
  getDynamicContent: (component: DynamicContentComponent, componentId: string) =>
    `${process.env.GATSBY_DYNAMIC_CONTENT}/${component}?id=${componentId}`,
} as const;
